import { DictionaryUser, ExtractUser, LoadingStatusEnum, DictionaryUserSchema, ExtractUserSchema } from "etl/types";
import { createAppAsyncThunk } from "../../../../store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type LoadUserRequest = {
	forceReload?: boolean
} | void;

type LoadUsersResponse = {
	extractUsers: ExtractUser[];
	dictionnaryUsers: DictionaryUser[];
};

export const loadUsers = createAppAsyncThunk<LoadUsersResponse, LoadUserRequest>(
	"etlData/loadUsers",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {

		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			const [dictionnaryUsers, extractUsers] = await Promise.all([
				extra.etlClient.findAll(DictionaryUserSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(ExtractUserSchema, { params: { etlImportUuid: selectedEtlImportUuid } })
			]);

			return {
				extractUsers,
				dictionnaryUsers,
			};
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (data, { getState }) => {
			if (data?.forceReload) return true;
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.usersLoadingStatus);
		}
	}
);
